import { useEffect, useState } from "react";
import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import Swiper from "react-id-swiper";
import { isMobile } from "react-device-detect";
import Skeleton from "react-loading-skeleton";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { getTopSellingJob } from "../../redux/actions/apiActions";
import { setCarPopup, setLoader } from "../../redux/actions/globalAction";
import Image from "next/image";
import { gtmTopSellingJobs } from "../../lib/google-tag-manager";
import LazyLoad from "react-lazyload";

const TopSelling = ({
  topSelling,
  getTopSellingJob,
  globalData,
  setCarPopup,
  setLoader,
}) => {
  const [swiper, setSwiper] = useState(null);
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(topSelling);
  }, [topSelling]);

  useEffect(() => {
    getTopSellingJob(globalData?.carData?.modelId);
  }, [globalData?.carData?.modelId]);

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  const params = {
    loop: true,
    slidesPerView: 5,
    grabCursor: true,
    lazyload: true,
    breakpoints: {
      1024: {
        slidesPerView: 5,
      },
      769: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 2,
      },
    },
  };
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div
      style={{
        marginBottom: "50px",
        paddingLeft: "30px",
        paddingRight: "30px",
      }}
      id="topSelling"
    >
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={12}>
            <div className="text-center title-anim">
              <div className="header-all">Top Selling Jobs</div>
            </div>
            {!globalData.carData?.brandId ? (
              <p className="text-center">
                <a
                  className="subHead-all  text-primary"
                  onClick={() => {
                    setCarPopup("brand");
                  }}
                >
                  Select your car to <u>view prices</u>
                </a>
              </p>
            ) : (
              <p className="text-center subHead-all ">
                Top jobs that other {globalData.carData?.brand} owners are
                buying
              </p>
            )}
          </Col>
        </Row>
        <Row>
          {data != "" && data != null ? (
            // {false ? (
            <Col xs={12} className="mt-2">
              <Slider {...settings}>
                {data.map((e, index) => (
                  <LazyLoad key={index}>
                    <div className="d-flex justify-content-center align-items-center flex-column top-selling-head">
                      <Link
                        href={`/services/${globalData.locationData?.data?.EmirateAreaSlug ||
                          "dubai"
                          }/${e.Slug}`}
                      >
                        <a className="w-100" onClick={() => {
                          gtmTopSellingJobs(e.Name)
                          setLoader(true)
                        }}>
                          <div className="top-selling-card">
                            <div className="top-selling-container">
                              <div className="top-selling-image-container">
                                <div
                                  style={{
                                    width: "100%",
                                    position: "relative",
                                    overflow: "hidden",
                                  }}
                                  className="img top-selling"
                                >
                                  <Image
                                    src={
                                      e.ImgUrl
                                    }
                                    alt="Recommended Workshops"
                                    layout="fill"
                                    objectFit="cover"
                                  />
                                </div>
                                {/* <img
                                src={`${e.ImgUrl}`}
                                width={"100%"}
                                className="top-selling"
                              /> */}
                                {e.Offer && (
                                  <div
                                    className="product-discount"
                                    title={
                                      "Offer Available"
                                      // variant.Offer.PromotionPercentValue
                                      //   ? variant.Offer.PromotionPercentValue + "% OFF"
                                      //   : "AED" + variant.Offer.PromotionFlatValue + " OFF"
                                    }
                                  >
                                    <img src="/assets/discount.svg" alt="discount"/>
                                    Offer Available
                                    {/* {variant.Offer.PromotionPercentValue
                    ? variant.Offer.PromotionPercentValue + "% OFF"
                    : "AED" + variant.Offer.PromotionFlatValue + " OFF"} */}
                                  </div>
                                )}
                                <div className="overlay" />
                                <div className="top-selling-details">
                                  <div
                                    className="top-sell-text"
                                    style={{
                                      color: "#fff",
                                      margin: "1px",
                                      zIndex: 4,
                                      fontWeight: "500",
                                      fontSize: 17,
                                    }}
                                  >
                                    {e.Name}
                                  </div>
                                  {globalData?.carData?.modelId && (
                                    <div
                                      className="top-sell-text"
                                      style={{
                                        color: "#FFF100",
                                        margin: "1px",
                                        zIndex: 4,
                                        fontWeight: "600",
                                        fontSize: 16,
                                      }}
                                    >
                                      AED {e.Cost}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </Link>
                    </div>
                  </LazyLoad>
                ))}
              </Slider>
            </Col>
          ) : (
            <Col
              lg={12}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="text-center w-100">
                {/* Test Area */}
                {/* <Image
                  src={LoadingImage}
                  alt="Loader"
                  height={280}
                  width={280}
                /> */}
                {/* <img src="/assets/search-image.png" alt="Loader" height={280} /> */}
                <Skeleton style={{ width: "100%", height: "280px" }} />
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getTopSellingJob: (mId) => {
      dispatch(getTopSellingJob(mId));
    },
    setCarPopup: (flag) => {
      dispatch(setCarPopup(flag));
    },
    setLoader: (flag) => {
      dispatch(setLoader(flag));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TopSelling);

// getTopSellingJob
